/**
 * @internal
 * Canonical version of the Tempo library.
 *
 * ⚠️ This file is auto-updated by `npm run build:version` (see `bin/update-version.mjs`).
 * Do NOT edit manually — your changes will be overwritten on the next build.
 */
export const TEMPO_VERSION = '3.11.1';
